export default __webpack_public_path__ + "static/media/Major Rune Stone of the Tireless Defender.7516fdf6.jpg";